import { getReportTrendLabel } from "./helper";

jQuery(function ($) {
  if ($(".data-archive-block").length > 0) {
    // console.log("Data Archive Ready");

    const baseUrl = $("#base-url").data("base-url");
    let currPage = 1;
    let totalPages = 0;
    let timeoutVar;
    let blockApi = false;
    let downloadCsvUrl;
    let activeParams = "";
    let activeTextSearch = [];

    /////////////////////////////////////////////////////////////////////////////
    // API tags and countrie ////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////////////

    // API settings
    const settings = {
      url: baseUrl + "api/idea_country/dataarchiveparamsresource",
      method: "GET",
      timeout: 0,
      headers: {
        "Content-Type": "application/json",
      },
      error: function (error) {
        console.log("error", error);
      },
    };

    // Ajax call to get tags and countries
    $.ajax(settings).done(function (response) {
      let activeTags = [];

      const apiTags = response.tags;

      // console.log(response.tags);

      const regionsAndCountries = response.regions_and_countries;

      const sortedData = Object.fromEntries(
        Object.entries(regionsAndCountries).sort((a, b) =>
          a[0].localeCompare(b[0])
        )
      );

      // let apiTags = [
      //   { "label": "Democracy", "id": 1 },
      //   { "label": "Demonstration", "id": 2 },
      //   { "label": "Election", "id": 3 },
      //   { "label": "Voting", "id": 4 },
      // ];

      ////////////////////////////
      // Free text search ////////
      ////////////////////////////

      // Handler text search input field
      $("#input-textsearch").on("keyup", function (event) {
        if (event.keyCode === 13) {
          searchKeywords();
        }
      });

      $(".keyword-search-icon").on("click", function (event) {
        event.preventDefault();
        searchKeywords();
      });

      function searchKeywords() {
        const keyword = $("#input-textsearch").val();
        const searchTag = { id: null, label: keyword, type: "keyword" };
        addActiveTags(searchTag);
        getResultsWithParams(activeTags);
        $("#input-textsearch").val("");
      }

      /////////////////////////////////////////////////////////////////////////////
      // Tags search //////////////////////////////////////////////////////////////
      /////////////////////////////////////////////////////////////////////////////

      $("#reset-search-input").on("click", function () {
        $("#input-tags").val("");
        renderAvailableSearchTags();
      });

      // Handler for tags search autocomplete
      $("#input-tags").on("keyup", function () {
        renderAvailableSearchTags();
      });

      function renderAvailableSearchTags() {
        const value = $("#input-tags").val();
        const tagsFoundContainer = $("#tags-found-container");

        let tagsFound = [];

        if (value.length > 0) {
          $("#reset-search-input").show();
        } else {
          $("#reset-search-input").hide();
        }

        // Start auto search of tags when user keyed in 2 charcters or more
        if (value.length > 1) {
          tagsFound = apiTags.filter((item, index) => {
            return (
              item.label.toLowerCase().indexOf(value.toLowerCase(), 0) >= 0
            );
          });
        }

        tagsFoundContainer.find(".tag-found").remove();
        tagsFoundContainer.addClass("hidden");

        if (tagsFound.length > 0) {
          let tagsRendered = 0;

          $.each(tagsFound, function () {
            const label = $(this)[0].label;
            const id = $(this)[0].id;

            const foundInActiveTags = activeTags.find((item) => {
              return item.id === id && item.type === "tag";
            });

            if (foundInActiveTags === undefined) {
              tagsFoundContainer.append(
                '<div class="tag-found" data-id="' +
                  id +
                  '" data-type="tag">' +
                  label +
                  "</div>"
              );
              tagsRendered++;
            }
          });

          if (tagsRendered > 0) {
            tagsFoundContainer.removeClass("hidden");
          }

          $(".tag-found").on("click", function () {
            const id = $(this).data("id");
            const type = $(this).data("type");
            const label = $(this).text();

            const tag = {
              id,
              type,
              label,
            };

            // Add to active tags
            addActiveTags(tag);
            getResultsWithParams(activeTags);
          });
        }
      }

      /////////////////////////////////////////////////////////////////////////////
      // Active tags //////////////////////////////////////////////////////////////
      /////////////////////////////////////////////////////////////////////////////

      function addActiveTags(tag) {
        const found = activeTags.find((item) => {
          if (item.type === "keyword") {
            return item.label === tag.label && item.type === tag.type;
          }
          return item.id === tag.id && item.type === tag.type;
        });

        if (found === undefined) {
          activeTags.push(tag);
        }

        renderActiveTags();
        renderAvailableSearchTags();
      }

      function removeActiveTag(tag) {
        let foundIndex = -1;

        activeTags.forEach((item, index) => {
          if (item.id === tag.id && item.type === tag.type) {
            foundIndex = index;
          }
        });

        if (foundIndex >= 0) {
          activeTags.splice(foundIndex, 1);
        }

        if (tag.type === "time_from" || tag.type === "time_to") {
          $("select.select-time-range[data-type=" + tag.type + "]").val("");
          $("select.select-time-range[data-type=" + tag.type + "]").trigger(
            "change"
          );
        }

        if (tag.type === "extra") {
          $("input.checkbox-extra-filter[value=" + tag.id + "]").prop(
            "checked",
            false
          );
        }

        renderActiveTags();
        renderAvailableSearchTags();
        // console.log('removeActiveTag', activeTags);

        clearTimeout(timeoutVar);

        timeoutVar = setTimeout(() => {
          getResultsWithParams(activeTags);
        }, 250);

        // getResultsWithParams(activeTags);
      }

      // Refresh active tags list
      function renderActiveTags() {
        $(".das-tag").remove();

        if (activeTags.length > 0) {
          $.each(activeTags, function () {
            const id = $(this)[0].id;
            const type = $(this)[0].type;
            const label = $(this)[0].label;

            const additionalclass =
              type === "keyword" ? "das-tag-freetext" : "";

            $(
              `<div class="!capitalize das-tag ${additionalclass}">${label}<div class="das-tag-remove" data-id="${id}" data-type="${type}"></div></div>`
            ).insertBefore($("#remove-all-active-tags"));
          });

          // Remove a tag click handler
          $("body")
            .find(".das-tag-remove")
            .on("click", function () {
              const id = $(this).data("id");
              const type = $(this).data("type");
              const label = $(this).text();

              const tag = {
                id,
                type,
                label,
              };

              removeActiveTag(tag);

              if (type == "country") {
                vSelectCountries.updateOption(id, false);
              }

              if (type == "aspect") {
                aodSelect.updateOption(id, false);
              }

              if (type == "trend") {
                trendSelect.updateOption(id, false);
              }

              // console.log('before vSelectCountries.updateOption');
            });

          $(".active-seach-tags-element").removeClass("!hidden");
        } else {
          $(".active-seach-tags-element").addClass("!hidden");
        }
      }

      $("#remove-all-active-tags").on("click", function () {
        // console.log('activeTags', activeTags);
        blockApi = true;

        vSelectCountries.unselectAll();
        aodSelect.unselectAll();
        trendSelect.unselectAll();
        $("#month_from").val("");
        $("#month_from").trigger("change");
        $(".checkbox-extra-filter").prop("checked", false);

        activeTags = [];
        renderActiveTags();
        renderAvailableSearchTags();

        blockApi = false;

        getResults();
      });

      /////////////////////////////////////////////////////////////////////////////
      // Regions & countries //////////////////////////////////////////////////////
      /////////////////////////////////////////////////////////////////////////////
      const selectCountriesElm = $("#select-countries");

      $.each(sortedData, function () {
        const region = $(this)[0];
        // console.log('region', region.region);

        const optGroup = $(
          '<optgroup label="' + region.region + '"></optgroup>'
        );

        selectCountriesElm.append(optGroup);

        $.each(region.countries, function () {
          const country = $(this)[0];

          optGroup.append(
            '<option value="' + country.id + '">' + country.label + "</option>"
          );
        });
      });

      const vSelectCountries = $(".my-vselect").vSelect({
        onChange: function (option) {
          const tag = {
            id: option.value,
            type: "country",
            label: option.label,
          };

          if (option.checked) {
            addActiveTags(tag);
          } else {
            removeActiveTag(tag);
          }

          clearTimeout(timeoutVar);

          timeoutVar = setTimeout(() => {
            getResultsWithParams(activeTags);
          }, 250);
        },
      });

      const aodSelect = $(".my-aodSelect").aodSelect({
        onChange: function (option) {
          const tag = {
            id: option.value,
            type: "aspect",
            label: option.label,
          };

          if (option.checked) {
            addActiveTags(tag);
          } else {
            removeActiveTag(tag);
          }

          clearTimeout(timeoutVar);

          timeoutVar = setTimeout(() => {
            getResultsWithParams(activeTags);
          }, 250);
        },
      });

      const trendSelect = $(".my-trendSelect").trendSelect({
        onChange: function (option) {
          const tag = {
            id: option.value,
            type: "trend",
            label: option.label,
          };

          if (option.checked) {
            addActiveTags(tag);
          } else {
            removeActiveTag(tag);
          }

          clearTimeout(timeoutVar);

          timeoutVar = setTimeout(() => {
            getResultsWithParams(activeTags);
          }, 250);
        },
      });

      /////////////////////////////////////////////////////////////////////////////////////
      // Set up filters for Attributes and Countries based on hard coded select elements //
      /////////////////////////////////////////////////////////////////////////////////////

      let apiAttributes = [];
      let apiCountries = [];

      $(".my-vselect")
        .find("option")
        .each(function (index) {
          const oEl = $(this);

          apiCountries[oEl.attr("value")] = oEl.text();
        });

      $(".my-aodSelect")
        .find("option")
        .each(function (index) {
          const aOd = $(this);

          apiAttributes[aOd.attr("value")] = aOd.text();
        });

      $(".my-aodSelect")
        .find("optgroup")
        .each(function (index) {
          const aOd = $(this);

          apiAttributes[aOd.attr("label")] = aOd.attr("label");
        });

      // console.log(apiCountries);
      // console.log(apiAttributes);

      /////////////////////////////////////////////////////////////////////////////
      // Time range ///////////////////////////////////////////////////////////////
      /////////////////////////////////////////////////////////////////////////////

      const today = new Date();
      populateTimeToOptions($("#month_from"));

      $(".select-time-range").on("change", function () {
        const thisElm = $(this);
        const type = thisElm.data("type");
        const label = thisElm.data("label");
        const value = thisElm.val();
        const textLabel = thisElm.find("option:selected").text();

        const isValueIsSelected = value == "" ? false : true;

        // For time-from select list
        if (type === "time_from") {
          activeTags = activeTags.filter((item, key) => {
            return item.type !== "time_from" && item.type !== "time_to";
          });

          // Remove all options from time-to select list
          $("#month_to option").each(function (index) {
            if (index > 0) {
              $(this).remove();
            }
          });

          // If time-from has value
          if (isValueIsSelected) {
            const newYearFrom = parseInt(value.substring(0, 4));
            const newMonthFrom = parseInt(value.substring(5, 7));

            // Repopulate time to options starting from current selected time-from value
            // - 2 so that starting month is same as time-from select list
            populateTimeToOptions(
              $("#month_to"),
              newMonthFrom - 1,
              newYearFrom,
            );
            $("#month_to").prop("disabled", false);

            // Add active tag of time-from
            const tag = {
              id: value, // Value of select list
              label: label + textLabel,
              type: type,
            };

            addActiveTags(tag);
          } else {
            // Disable time to if time from has no selected value
            $("#month_to").prop("disabled", true);
            renderActiveTags();
          }
        }

        if (type === "time_to") {
          // Remove active tags
          $.each(activeTags, function (index) {
            const tag = $(this)[0];

            if (tag.type === "time_to") {
              removeActiveTag(tag);
            }
          });

          if (isValueIsSelected) {
            const tag = {
              id: value,
              label: label + textLabel,
              type: type,
            };

            addActiveTags(tag);
          }
        }
        getResultsWithParams(activeTags);
      });

      function populateTimeToOptions(elm, eM = 7, eY = 2022) {
          const endMonth = eM; // Month start with 0
          const endYear = eY;
          const thisMonth = today.getMonth();
          const thisYear = today.getFullYear();

          const months = [
              "January",
              "February",
              "March",
              "April",
              "May",
              "June",
              "July",
              "August",
              "September",
              "October",
              "November",
              "December",
          ];

          let countYear = thisYear;
          let countMonth = thisMonth;

          while (countYear > endYear || (countYear === endYear && countMonth >= endMonth)) {
              const label = months[countMonth] + " " + countYear;

              let monthString = (countMonth + 1) + "";

              if (monthString.length < 2) {
                  monthString = "0" + monthString;
              }

              let value = countYear + "-" + monthString;

              elm.append('<option value="' + value + '">' + label + "</option>");

              countMonth--;

              if (countMonth < 0) {
                  countMonth = 11;
                  countYear--;
              }
          }
      }

      /////////////////////////////////////////////////////////////////////////////
      // Checkboxes ///////////////////////////////////////////////////////////////
      /////////////////////////////////////////////////////////////////////////////

      $(".checkbox-extra-filter").on("click", function () {
        const elm = $(this);
        const value = elm.val();
        const label = elm.data("label");
        const checked = elm.is(":checked");
        const tag = {
          id: value,
          label,
          type: "extra",
        };

        if (checked) {
          addActiveTags(tag);
        } else {
          removeActiveTag(tag);
        }

        getResultsWithParams(activeTags);
      });

      /////////////////////////////////////////////////////////////////////////////
      // Load page by URL Parameter ///////////////////////////////////////////////
      /////////////////////////////////////////////////////////////////////////////

      // console.log(apiTags);
      // console.log(apiCountries);
      // console.log(apiAttributes);

      const queryString = window.location.search;

      let paramTag;

      if (queryString !== "") {
        let paramsArray = [];
        const urlParams = new URLSearchParams(window.location.search);

        // Retrieve all parameters
        urlParams.forEach((value, key) => {
          paramsArray[key] = value.split(",");
        });

        for (const key in paramsArray) {
          const value = paramsArray[key];

          if (key === "country") {
            value.forEach((value) => {
              paramTag = {
                id: value,
                type: "country",
                label: apiCountries[value],
              };
              addActiveTags(paramTag);
              // $(`.vselect-container .vselect-option.child input[type="checkbox"][value="${value}"]`).prop('checked', true).trigger('change');
            });
          } else if (key === "atBu") {
            value.forEach((value) => {
              paramTag = {
                id: value,
                type: "aspect",
                label: apiAttributes[value],
              };
              addActiveTags(paramTag);
              // $(`.vselect-container .vselect-option input[type="checkbox"][value="${value}"]`).prop('checked', true).trigger('change');
            });
          } else if (key === "trn") {
            value.forEach((value) => {
              paramTag = {
                id: value,
                type: "trend",
                label: value,
              };
              addActiveTags(paramTag);
              // $(`.vselect-option.child input[type="checkbox"][value="${value}"]`).prop('checked', true).trigger('change');
            });
          } else if (key === "from" || key === "to") {
            const monthsArray = [];
            monthsArray.push(
              "January",
              "February",
              "March",
              "April",
              "May",
              "June",
              "July",
              "August",
              "September",
              "October",
              "November",
              "December"
            );

            value.forEach((value) => {
              const yearAndMonth = value.split("-");
              paramTag = {
                id: value,
                type: key === "from" ? "time_from" : "time_to",
                label:
                  (key === "from" ? "From: " : "To: ") +
                  monthsArray[yearAndMonth[1] - 1] +
                  " " +
                  yearAndMonth[0],
              };
              addActiveTags(paramTag);
              // $(`${key === "from" ? "#month_from":"#month_to"}`).trigger('change').val(value.toString()).trigger('change');
            });
          } else if (key === "etw") {
            value.forEach((value) => {
              paramTag = {
                id: "etw",
                type: "extra",
                label: "Events to watch",
              };
              addActiveTags(paramTag);
              // $('input.checkbox-extra-filter[value=etw]').prop('checked', true).trigger('change');
            });
          } else if (key === "rfe") {
            value.forEach((value) => {
              paramTag = {
                id: "rfe",
                type: "extra",
                label: "Red flagged events",
              };
              addActiveTags(paramTag);
              // $('input.checkbox-extra-filter[value=rfe]').prop('checked', true).trigger('change');
            });
          } else if (key === "ee") {
            value.forEach((value) => {
              paramTag = {
                id: "ee",
                type: "extra",
                label: "Elections",
              };
              addActiveTags(paramTag);
              // $('input.checkbox-extra-filter[value=ee]').prop('checked', true).trigger('change');
            });
          } else if (key === "bu") {
            value.forEach((value) => {
              paramTag = {
                id: "bu",
                type: "extra",
                label: "Breaking Updates",
              };
              addActiveTags(paramTag);
              // $('input.checkbox-extra-filter[value=bu]').prop('checked', true).trigger('change');
            });
          } else if (key === "tag") {
            value.forEach((value) => {
              let paramTagFound = apiTags.filter((tag, index) => {
                return tag.id === parseInt(value);
              });

              paramTag = {
                id: paramTagFound[0].id,
                label: paramTagFound[0].label,
                type: "tag",
              };

              addActiveTags(paramTag);
              // getResultsWithParams(activeTags);
              // $('input.checkbox-extra-filter[value=bu]').prop('checked', true).trigger('change');
            });
          } else if (key === "keywords") {
            value.forEach((value) => {
              paramTag = {
                id: null,
                label: value,
                type: "keyword",
              };

              addActiveTags(paramTag);
              // getResultsWithParams(activeTags);
              // $('input.checkbox-extra-filter[value=bu]').prop('checked', true).trigger('change');
            });
          }
        }
      }
      getResultsWithParams(activeTags);
    }); // End of $.ajax for tags and countries

    $(".page-nav.prev").on("click", function () {
      if (currPage <= 1) {
        return;
      }

      currPage--;

      if (activeParams === "") {
        getResults("?page=" + currPage);
      } else {
        getResults(activeParams + "&page=" + currPage);
      }
    });

    $(".page-nav.next").on("click", function () {
      if (currPage >= totalPages) {
        return;
      }

      currPage++;

      if (activeParams === "") {
        getResults("?page=" + currPage);
      } else {
        getResults(activeParams + "&page=" + currPage);
      }
    });

    function updateSearchBarURL(page, url) {
      // console.log(url);
      if (typeof history.pushState !== "undefined") {
        // History.pushState cant handle empty URL, so if an empty URL is provided. The URL will be altered from the "?" forward.
        if (url.trim() === "") {
          // Handle the case of an empty URL
          var baseUrl = window.location.href.split("?")[0];
          history.pushState({}, page, baseUrl);
        } else {
          var obj = { Page: page, Url: url };
          history.pushState(obj, obj.Page, obj.Url);
        }
      } else {
        alert("Browser does not support HTML5.");
      }
    }

    function getResults(params = "") {
      /////////////////////////////////////////////////////////////////////////////
      // API get data archive results /////////////////////////////////////////////
      /////////////////////////////////////////////////////////////////////////////

      // console.log('function getResults / params:', params, 'active:', activeParams);

      let url = baseUrl + "api/idea_country/dataarchiveresource";

      // console.log(params);
      updateSearchBarURL("Filter Tags", params);

      if (params !== "") {
        url += params;
        downloadCsvUrl = url + "&download=1";
      } else {
        downloadCsvUrl = url + "?download=1";
      }

      $("#download-csv").attr("href", downloadCsvUrl);

      // console.log('API URL: ', url);

      // API settings
      const settings = {
        url: url,
        method: "GET",
        timeout: 0,
        headers: {
          "Content-Type": "application/json",
        },
        error: function (error) {
          console.log("error", error);
        },
      };

      $("#data-archive-loading-blocker").fadeIn(1000);

      const resultsElm = $("#data-archive-results");

      $("#message-no-results").hide();

      resultsElm.html("");
      $(".pagination").hide();

      $.ajax(settings).done(function (response) {
        // console.clear();
        // console.log('getResults response', response.total_pages, response.data);

        const data = response.data;

        $(".page-nav").prop("disabled", false);
        $(".page-nav").css("opacity", 1);
        $(".page-nav").css("pointer-events", "auto");

        if (data === undefined) {
          $("#message-no-results").show();
          $("#data-archive-loading-blocker").fadeOut(1000);
          return;
        } else {
          totalPages = response.total_pages;

          $("#current-page").text(currPage);
          $("#total-pages").text(response.total_pages);

          if (currPage == 1) {
            $("#button-prev-page").prop("disabled", true);
            $("#button-prev-page").css("opacity", 0.4);
            $("#button-prev-page").css("pointer-events", "none");
          }

          if (currPage >= response.total_pages) {
            $("#button-next-page").prop("disabled", true);
            $("#button-next-page").css("opacity", 0.4);
            $("#button-next-page").css("pointer-events", "none");
          }

          if (totalPages > 1) {
            $(".pagination").show();
          }
        }

        $.each(data, function (index) {
          const value = $(this)[0];

          // Prep flag variables
          var flag_red = "";
          var flag_watch = "";
          var flag_election = "";

          // Test flag's status
          if (value.field_red_flag_value == 1) {
            if (value.tooltip_red_flag != "") {
              flag_red +=
                '<div class="attribute-tooltip-hover" data-tooltip="' +
                value.tooltip_red_flag +
                '">';
            }
            flag_red +=
              '<img src="' +
              baseUrl +
              'themes/custom/gsod/src/assets/icons/icon-red-flag.svg" alt="Red flag" class="ml-4">';
            if (value.tooltip_red_flag != "") {
              flag_red += "</div>";
            }
          }
          if (value.field_watch_flag_value == 1) {
            if (value.tooltip_watchflag != "") {
              flag_watch +=
                '<div class="attribute-tooltip-hover" data-tooltip="' +
                value.tooltip_watchflag +
                '">';
            }
            flag_watch +=
              '<img src="' +
              baseUrl +
              'themes/custom/gsod/src/assets/icons/icon-watch-flag.svg" alt="Watch flag" class="ml-4">';
            if (value.tooltip_watchflag != "") {
              flag_watch += "</div>";
            }
          }
          if (value.field_election_flag_value == 1) {
            if (value.tooltip_electionflag != "") {
              flag_election +=
                '<div class="attribute-tooltip-hover" data-tooltip="' +
                value.tooltip_electionflag +
                '">';
            }
            flag_election +=
              '<img src="' +
              baseUrl +
              'themes/custom/gsod/src/assets/icons/icon-election-flag.svg" alt="Election flag" class="ml-4">';
            if (value.tooltip_electionflag != "") {
              flag_election += "</div>";
            }
          }

          // Combines the flags with the report title
          var combinedFlags =
            "<span>" +
            value.title +
            "</span>" +
            flag_red +
            flag_watch +
            flag_election;

          const cardElm = $(
            "<div class=\"data-archive-card relative before:content-[''] before:block before:shadow-cdCard before:pointer-events-none before:absolute before:top-0 before:bottom-0 before:left-[-1.5rem] before:right-[-1.5rem] lg:before:right-0\"></div>"
          );

          const eventElm = $('<div class="py-6 lg:py-10 lg:pr-10"></div>');

          eventElm.append(
            $(
              '<h3 class="h4 flex items-center justify-start">' +
                combinedFlags +
                "</h3>"
            )
          );

          eventElm.append($('<h4 class="h5">' + value.heading + "</h4>"));

          // eventElm.append(parsedBody);
          eventElm.append($('<div class="data-archive-card--content">' + value.body + '</div>'));

          const permalink =
            baseUrl.substring(0, baseUrl.length - 1) + value.permalink;
          const newPermalink = permalink + "?pid=" + value.pid;

          eventElm.append(
            $(
              '<div class="gsod-jump-links mb-5"><a href="' +
                newPermalink +
                '" class="jump-link uppercase"><span class="text-xs">Read more</span></a></div>'
            )
          );

          const tagsAndAttributesElm = $(
            '<div class="flex justify-between items-start flex-shrink gap-x-8"></div>'
          );
          const gsodTagsElm = $(
            '<div class="gsod-tags flex flex-wrap gap-2"></div>'
          );

          if (value.tags !== null) {
            $.each(value.tags, function (index) {
              const tag = $(this)[0];
              const tagElm = $(
                '<a href="' +
                  baseUrl +
                  "searchable-archive?tag=" +
                  tag.id +
                  '" class="gsod-tag">' +
                  tag.label +
                  "</a>"
              );
              gsodTagsElm.append(tagElm);
            });

            tagsAndAttributesElm.append(gsodTagsElm);
          } else {
            tagsAndAttributesElm.append("<div></div>");
          }

          const gsodAttributesElm = $(
            '<div class="gsod-attributes flex flex-shrink-0 gap-x-1"></div>'
          );

          let attributeValue;

          // console.log('value.attributes', value.attributes);

          // Representation
          attributeValue = value.attributes.att_representation;

          if (attributeValue !== "") {
            const valueLabel = getReportTrendLabel(attributeValue);
            attributeValue = attributeValue.toLowerCase();
            gsodAttributesElm.append(
              '<div class="attribute-tooltip-hover relative" data-tooltip="Representation (' +
                valueLabel +
                ')"><img src="' +
                baseUrl +
                "themes/custom/gsod/src/assets/icons/icon-representation-" +
                attributeValue +
                '.svg" alt="Representation ' +
                attributeValue +
                '" class="gsod-attribute"></div>'
            );
          }

          // Rights
          attributeValue = value.attributes.att_rights;

          if (attributeValue !== "") {
            const valueLabel = getReportTrendLabel(attributeValue);
            attributeValue = attributeValue.toLowerCase();
            gsodAttributesElm.append(
              '<div class="attribute-tooltip-hover relative" data-tooltip="Rights (' +
                valueLabel +
                ')"><img src="' +
                baseUrl +
                "themes/custom/gsod/src/assets/icons/icon-rights-" +
                attributeValue +
                '.svg" alt="Rights ' +
                attributeValue +
                '" class="gsod-attribute"></div>'
            );
          }

          // Participation
          attributeValue = value.attributes.att_participation;

          if (attributeValue !== "") {
            const valueLabel = getReportTrendLabel(attributeValue);
            attributeValue = attributeValue.toLowerCase();
            gsodAttributesElm.append(
              '<div class="attribute-tooltip-hover relative" data-tooltip="Participation (' +
                valueLabel +
                ')"><img src="' +
                baseUrl +
                "themes/custom/gsod/src/assets/icons/icon-participation-" +
                attributeValue +
                '.svg" alt="Participation ' +
                attributeValue +
                '" class="gsod-attribute"></div>'
            );
          }

          // Rule of law
          attributeValue = value.attributes.att_rule_of_law;

          if (attributeValue !== "") {
            const valueLabel = getReportTrendLabel(attributeValue);
            attributeValue = attributeValue.toLowerCase();
            gsodAttributesElm.append(
              '<div class="attribute-tooltip-hover relative" data-tooltip="Rule of law (' +
                valueLabel +
                ')"><img src="' +
                baseUrl +
                "themes/custom/gsod/src/assets/icons/icon-rule_of_law-" +
                attributeValue +
                '.svg" alt="Rule of law ' +
                attributeValue +
                '" class="gsod-attribute"></div>'
            );
          }

          $.each(value.secondaryAttributes, function (key, value) {
            if (value == "1") {
              const html = getSecondaryIcon(key);
              gsodAttributesElm.append(html);
            }
          });

          // // Impartial Administration
          // attributeValue = value.attributes.impartial_administration;

          // if (attributeValue !== '') {
          //   attributeValue = attributeValue.toLowerCase();
          //   gsodAttributesElm.append('<div class="attribute-tooltip-hover relative" data-tooltip="Impartial Administration"><img src="' + baseUrl + 'themes/custom/gsod/src/assets/icons/icon-impartial-administration-'+attributeValue+'.svg" alt="Impartial administration '+attributeValue+'" class="gsod-attribute"></div>');
          // }

          tagsAndAttributesElm.append(gsodAttributesElm);

          eventElm.append(tagsAndAttributesElm);

          cardElm.append(eventElm);

          setTimeout(() => {
            resultsElm.append(cardElm);
            $("#data-archive-loading-blocker").fadeOut(1000);
          }, 250);
        });

        setTimeout(() => {
          highlightKeywords();
        }, 1000);

        // Tooltip for attributes
        $("body").on("mouseenter", ".attribute-tooltip-hover", function () {
          const tooltip = $(this).data("tooltip");
          const tt = $(this).find("img");

          if ($(".attribute-tooltip").length) {
            $(".attribute-tooltip").remove();
          }

          $("body").append(
            '<div class="attribute-tooltip"><div class="tooltip-content">' +
              tooltip +
              "</div></div>"
          );

          $(".attribute-tooltip").css("top", tt.offset().top);
          $(".attribute-tooltip").css(
            "left",
            tt.offset().left + tt.width() / 2
          );
        });

        $("body").on("mouseleave", ".attribute-tooltip-hover", function () {
          $(".attribute-tooltip").remove();
        });
      });
    }

    const secondaryAttributes = {
      att_representation_secondary: {
        label: 'Representation',
        icon: 'icon-representation',
      },
      att_rights_secondary: {
        label: 'Rights',
        icon: 'icon-rights',
      },
      att_participation_secondary: {
        label: 'Participation',
        icon: 'icon-participation',
      },
      att_rule_of_law_secondary: {
        label: 'Rule of law',
        icon: 'icon-rule_of_law',
      }
    }

    function getSecondaryIcon(key) {
      const html = '<div class="attribute-tooltip-hover relative" data-tooltip="' + secondaryAttributes[key].label + ' (secondary)"><img src="' +
        baseUrl +
        'themes/custom/gsod/src/assets/icons/' + secondaryAttributes[key].icon + '-neutral.svg" alt="' + secondaryAttributes[key].label + ' (secondary)" class="gsod-attribute"></div>';

      return html;
    }

    ///////////////////////////////////////////////
    // Highlight keywords
    //////////////////////////////////////////////

    function highlightKeywords() {
        const urlParams = new URLSearchParams(window.location.search);
        const keywords = urlParams.get("keywords");

        if (keywords === null) {
          return;
        }

        const keywordsArray = keywords.split(",");

        let dictionary = [];

        keywordsArray.forEach((keyword) => {
          dictionary.push({
            word: keyword.trim().toLowerCase(),
          });
        });

        dictionary.sort(function (a, b) {
          var wordA = a.word.toLowerCase();
          var wordB = b.word.toLowerCase();
        
          if (wordA < wordB) {
            return 1;
          } else if (wordA > wordB) {
            return -1;
          } else {
            return 0;
          }
        });

        $(".data-archive-card--content").each(function () {
          const elm = $(this);
          // let text = elm.html();
        
          // Loop dictionary
          $.each(dictionary, function (index, searchItem) {
            // Define a regex to match the word only within text nodes (ignoring tags and attributes), with case-insensitive search
            // let regex = new RegExp(`(>[^<]*)\\b(${searchItem.word})\\b([^<]*<)`, 'gi');

            // console.log('regex', regex);

            // // Replace matches with a span-wrapped version of the word, preserving the original case
            // text = text.replace(regex, (match, before, matchedWord, after) => {
            //   return `${before}<span class="word-highlight font-bold text-black">${matchedWord}</span>${after}`;
            // });





            // Load the HTML content into a jQuery object
            // let $content = $(text);

            // Define a function to wrap text nodes containing the word
            elm.find("*").contents().each(function() {
                if (this.nodeType === Node.TEXT_NODE) {
                    // Replace the search word only in text nodes
                    $(this).replaceWith($(this).text().replace(new RegExp(`(${searchItem.word})`, 'gi'), '<span class="word-highlight font-bold">$1</span>'));
                }
            });

            // Get the updated HTML
            // const text = elm.prop('outerHTML');










            // Update the element's HTML with the modified content
            // elm.html(text);

            
        
            // Remove any nested class due to repeating words in dictionary
            // elm.find('.word-highlight').each(function() {
            //   const wthElm = $(this);
      
            //   wthElm.find('.word-highlight').each(function() {
            //     $(this).contents().unwrap();
            //   });
            // });

            // Remove highlights in <a> tags
            // elm.find('a').each(function() {
            //   let html = $(this).html();
            //   html = html.replace(/<\/?span[^>]*>/g, ''); // Remove <span> tags with any attributes
            //   $(this).html(html);
            // });
          });
        });
    }

    function highlightKeywords2(text, keywords) {
      const dictionary = keywords.split(",");
      var newArray = [];

      // Loop dictionary
      $.each(dictionary, function (index, searchItem) {
        // console.log("search item", searchItem);
        // console.log("text item", text);

        // Find the dictionary word
        if (text.toLowerCase().indexOf(searchItem.toLowerCase()) >= 0) {
          // Split original text to get
          var wordToReplace = searchItem;

          var escapedWordToReplace = wordToReplace.replace(
            /[.*+?^${}()|[\]\\]/g,
            "\\$&"
          );

          var regex = new RegExp("(" + escapedWordToReplace + ")", "gi");
          // var regex = new RegExp(`([^>]*?\\b${escapedWordToReplace}\\b[^<]*?)`, "gi");
          var textArray = text.split(regex);

          // Loop the exploded text array
          $.each(textArray, function (index2, item) {
            // Check if exploded item is the word we want
            if (item.toLowerCase() === searchItem.toLowerCase()) {
              // Wrap with class and push to new array
              newArray.push(
                '<span class="text-black font-bold">' +
                  item +
                  "</span>"
              );
            } else {
              // Not the word we want, push original item to new array
              newArray.push(item);
            }
          });
          //if paragraph has no matching words push anyway
        } else {
          newArray.push(text);
        }
      });
      return newArray.join(""); // Return the modified text
    }

    function getResultsWithParams(activeTags) {
      if (activeTags.length <= 0) {
        getResults();
        return;
      }

      let params = [];

      if (blockApi) {
        return;
      }
      // console.log('getResultsWithParams', activeTags);

      // console.log(activeTags);
      let keywords = activeTags.filter((item, key) => {
        return item.type === "keyword";
      });

      let tags = activeTags.filter((item, key) => {
        return item.type === "tag";
      });

      let countries = activeTags.filter((item, key) => {
        return item.type === "country";
      });

      let timeFrom = activeTags.filter((item, key) => {
        return item.type === "time_from";
      });

      let timeTo = activeTags.filter((item, key) => {
        return item.type === "time_to";
      });

      let etw = activeTags.filter((item, key) => {
        return item.id === "etw" && item.type === "extra";
      });

      let rfe = activeTags.filter((item, key) => {
        return item.id === "rfe" && item.type === "extra";
      });

      let ee = activeTags.filter((item, key) => {
        return item.id === "ee" && item.type === "extra";
      });

      let bu = activeTags.filter((item, key) => {
        return item.id === "bu" && item.type === "extra";
      });

      let atBu = activeTags.filter((item, key) => {
        return item.type === "aspect";
      });

      let trn = activeTags.filter((item, key) => {
        return item.type === "trend";
      });

      // console.log('Params', tags, '|', countries, '|', timeFrom, '|', timeTo, '|', etw, '|', rfe, '|', bu, '|', atBu);

      let temp = [];
      let tagParams;

      if (keywords.length > 0) {
        tagParams = "keywords=";

        $.each(keywords, function (index) {
          const value = $(this)[0];
          temp.push(value.label);
        });

        tagParams += temp.join(",");
        params.push(tagParams);
      }

      temp = [];
      if (tags.length > 0) {
        tagParams = "tag=";

        $.each(tags, function (index) {
          const value = $(this)[0];
          temp.push(value.id);
        });

        tagParams += temp.join(",");
        params.push(tagParams);
      }

      temp = [];
      let countryParams;

      if (countries.length > 0) {
        countryParams = "country=";

        $.each(countries, function (index) {
          const value = $(this)[0];
          temp.push(value.id);
        });

        countryParams += temp.join(",");
        params.push(countryParams);
      }

      let tempCollection;

      if (atBu.length > 0) {
        let aspectParams = "atBu=";
        tempCollection = [];
        $.each(atBu, function (index) {
          const value = $(this)[0];
          tempCollection.push(value.id);
        });

        aspectParams += tempCollection.join(",");
        params.push(aspectParams);
      }

      if (trn.length > 0) {
        let trendParams = "trn=";
        let trendCollection = [];
        $.each(trn, function (index) {
          const value = $(this)[0];
          trendCollection.push(value.id);
        });

        trendParams += trendCollection.join(",");
        params.push(trendParams);
      }

      if (timeFrom.length > 0) {
        params.push("from=" + timeFrom[0].id);
      }

      if (timeTo.length > 0) {
        params.push("to=" + timeTo[0].id);
      }

      if (etw.length > 0) {
        params.push("etw=1");
      }

      if (rfe.length > 0) {
        params.push("rfe=1");
      }

      if (ee.length > 0) {
        params.push("ee=1");
      }

      if (bu.length > 0) {
        params.push("bu=1");
      }

      let urlParams = "?" + params.join("&");

      // console.log('urlParams', urlParams);

      currPage = 1;
      activeParams = urlParams;
      getResults(urlParams);
    } // End of getResultsWithParams

    /////////////////////////////////////////////////////////////////////////////
    // Collapse for filters UI on mobile view ///////////////////////////////////
    /////////////////////////////////////////////////////////////////////////////

    const filtersCollapseToggle = $("#toggle-filters-collapse");
    const filtersCollapse = $("#collapse-filters");

    let filterCollapseHeight = $("#filter-collapse-body").height();
    filtersCollapse.css("height", filterCollapseHeight + "px");

    filtersCollapseToggle.on("click", function () {
      if ($(this).hasClass("active")) {
        // Collapse
        filterCollapseHeight = $("#filter-collapse-body").height();
        filtersCollapse.css("height", filterCollapseHeight + "px");

        setTimeout(() => {
          $(this).removeClass("active");
          filtersCollapse.addClass("close");
        }, 50);
      } else {
        // Expand
        filterCollapseHeight = $("#filter-collapse-body").height();
        filtersCollapse.css("height", filterCollapseHeight + "px");

        $(this).addClass("active");
        filtersCollapse.removeClass("close");

        setTimeout(() => {
          filtersCollapse.css("height", "auto");
        }, 100);
      }
    });
  } // End if
});
